import React, { useState } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CanadaFlag from "assets/images/canada-flag.png";
import VideoDialog from "components/VideoDialog";
import { FEATURES } from "pages/dtf-transfers/by-size/data";
import {
  PricingLine,
  FeatureGrid,
  FeatureItem,
  FeatureVideoLink,
} from "styles/pages/dtf-transfers/by-size";

// Replace with the Shirtly hot-peel tutorial YouTube video ID when available.
const HOT_PEEL_VIDEO_ID = "";

const ProductHeader = () => {
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  return (
    <>
      <PricingLine>
        <strong>Price $0.01/sq in</strong> | Printed by Shirtly.
      </PricingLine>

      <FeatureGrid>
        {FEATURES.map(({ icon: Icon, label, showInfo, videoLinkLabel }) => (
          <FeatureItem key={label}>
            <Icon />
            <span>
              {label}
              {videoLinkLabel && (
                <>
                  {" "}
                  <FeatureVideoLink
                    type="button"
                    onClick={() => HOT_PEEL_VIDEO_ID && setIsVideoOpen(true)}
                    disabled={!HOT_PEEL_VIDEO_ID}
                  >
                    {videoLinkLabel}
                  </FeatureVideoLink>
                </>
              )}
            </span>
            {showInfo && (
              <InfoOutlinedIcon style={{ fontSize: 16, color: "#9ca3af" }} />
            )}
          </FeatureItem>
        ))}
      </FeatureGrid>

      {HOT_PEEL_VIDEO_ID && (
        <VideoDialog
          open={isVideoOpen}
          toggle={() => setIsVideoOpen((open) => !open)}
          videoId={HOT_PEEL_VIDEO_ID}
        />
      )}
    </>
  );
};

export default ProductHeader;
